import React, { Component } from 'react';

import Conteudo from '../../Conteudo';
import Title from '../../components/Title';

import CadastroReserva from './CadastroReserva';
import ReservasEfetuadas from './ReservasEfetuadas';

import AuthProvider from '../../AuthProvider';

export default class extends Component {
  render() {
    return (
      <div>
        <Title value="Diego Rivera » Reservas" />
        <AuthProvider>
          {(_undefined, containsRole) => {
            let children = [];

            if (
              containsRole([
                'admin',
                'conselheiro',
                'sindico',
                'proprietario',
                'morador'
              ])
            ) {
              children.push(CadastroReserva, ReservasEfetuadas);
            } else if (containsRole(['porteiro', 'zelador'])) {
              children.push(CadastroReserva, ReservasEfetuadas);
            }

            return (
              children.length && (
                <Conteudo>
                  {children.map((Child, i) => (
                    <Child key={i} />
                  ))}
                </Conteudo>
              )
            );
          }}
        </AuthProvider>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/reserva/Index.js